import { useState } from "react";
import "./screen.css";
import "./styles.css";
import "./EditUser.css"; // Add this new CSS file for styles
import Sidebar from "./SideBar";
const LOGIN_API_URL = process.env.REACT_APP_LOGIN_API_URL;
function AddUser() {
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [name, setname] = useState("");
  const [organization, setorganization] = useState("");
  const [phone, setphone] = useState("");
  const [role, setRole] = useState("");

  const adduser = async () => {
    if (!username || !password || !role || !name) {
      alert("fill all the fields");
      return;
    }
    fetch(`${LOGIN_API_URL}/login.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: username?.toLowerCase(),
        password: password,
        role: role,
        organization: organization,
        phone: phone,
        username: name,
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
       // console.log(responseData);
        if (responseData.status === "Signup Successfully") {
          alert("User Added Successfully");
        } else {
          window.alert(responseData.status);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div style={{ display: "flex", height: "100vh", width: "100%" }}>
      {/* Sidebar */}
<Sidebar />
      {/* Main Content */}
      <div
        style={{
          flex: 1,
          padding: "30px",
          backgroundColor: "#fff",
          overflowY: "auto",
        }}
      >
        {/* Header (optional) */}
        <h1 style={{ marginBottom: 30, fontSize: "30px" }}>Add User</h1>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "12px",
            maxWidth: "600px",
            margin: "0 auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Username
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setname(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Email
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setusername(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Password
            </label>
            <input
              type="text"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div style={{ marginBottom: 30 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Role
            </label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                fontSize: "100%",
                backgroundColor: "#fff",
              }}
            >
              <option value="" disabled hidden>
                Select Role
              </option>
              <option value="Product Manager">Product Manager</option>
              <option value="Site Manager">Site Manager</option>
              <option value="Technician">Technician</option>
              <option value="User">User</option>
            </select>
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Phone
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setphone(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Organization
            </label>
            <input
              type="text"
              value={organization}
              onChange={(e) => setorganization(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              onClick={adduser}
              style={{
                padding: "12px 50px",
                background: "linear-gradient(135deg, #8ec5fc, #66aaff)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: "100%",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "background 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#005ecb")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  "linear-gradient(135deg, #8ec5fc, #66aaff)")
              }
            >
              Add User
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddUser;
